// Merchant, staff and brand dropdown choices.
// Split from constants.js — edit here, not the composer.

import { MERCHANT_USER_ROLE, PRIVILEGE_ATTRIBUTE, STAFF_ROLE, SYSTEM_USER } from '../Sections/auth'
import { STATUS } from '../Sections/core'
import { BOOLEAN_CHOICES, ECOUPON_ITEM, GLOBAL, MOBILE, PACKAGE_ITEM, PACKAGE_SUB_ITEM, PREORDER_ITEM, VALUE_UP_ECOUPON_ITEM, WECHAT_MP } from '../Sections/internal'
import { MERCHANT_DEVICE_TYPE } from '../Sections/types'

export const merchantChoices = {
    BRAND_APPROVE: {
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'R', name: { key: 'reject' } },
            { value: 'P', name: { key: 'pending' } },
        ],
    },
    BRAND: {
        TYPE: [
            { value: 'MERCHANT_BRAND_LOGO', name: 'MERCHANT_BRAND_LOGO' },
            { value: 'MERCHANT_BRAND_IMAGE', name: 'MERCHANT_BRAND_IMAGE' },
        ],
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'P', name: { key: 'pending' } },
        ],
    },
    BRAND_GROUP: {
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'P', name: { key: 'pending' } },
        ],
    },
    BRAND_PRODUCT: {
        TYPE: [
            // { value: "VALUE_UP_ECOUPON_ITEM", name: "VALUE_UP_ECOUPON_ITEM" },
            { value: PACKAGE_ITEM, name: PACKAGE_ITEM },
            // { value: PACKAGE_SUB_ITEM, name: PACKAGE_SUB_ITEM },
            { value: PREORDER_ITEM, name: PREORDER_ITEM },
            { value: ECOUPON_ITEM, name: ECOUPON_ITEM },
        ],
        CHANNEL: [
            { value: GLOBAL, name: GLOBAL },
            { value: MOBILE, name: MOBILE },
            // { value: "WECHAT_H5", name: "WECHAT_H5" },
            { value: WECHAT_MP, name: WECHAT_MP },
        ],
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'D', name: { key: 'deactive' } },
            { value: 'P', name: { key: 'pending' } },
        ],
        MERCHANT_PRODUCT: [...BOOLEAN_CHOICES],
    },
    MERCHANT_CONFIG: {
        BOOLEAN_OPTIONS: [...BOOLEAN_CHOICES],
        QUEUE_REMIND_RESET_QUOTA: [...BOOLEAN_CHOICES],
        QUEUE_CHANNEL_STATUS_CONTROL: [...BOOLEAN_CHOICES],
        QUEUE_QUICK_CHECK_IN: [...BOOLEAN_CHOICES],
        COUNTER_CALL_ENABLE: [...BOOLEAN_CHOICES],
        QUEUE_REJECT_TICKET_ENABLE: [...BOOLEAN_CHOICES],
        COUNTER_CONTROL_MODE: [
            { value: 'NONE', name: 'NONE' },
            { value: 'AUTO_DISPLAY_STATUS', name: 'AUTO_DISPLAY_STATUS' },
            { value: 'AUTO_COUNTER_STATUS', name: 'AUTO_COUNTER_STATUS' },
        ],
        PUBLISH_PRODUCT: [...BOOLEAN_CHOICES],
        CREATE_PRODUCT: [...BOOLEAN_CHOICES],
        SEND_PRODUCT: [...BOOLEAN_CHOICES],
        GULU_SLIDESHOW_ENABLE: [...BOOLEAN_CHOICES],
        TWO_FACTOR_LOGIN: [
            { value: 'NONE', name: 'NONE' },
            { value: 'SMS', name: 'SMS' },
            { value: 'EMAIL', name: 'EMAIL' },
            { value: 'WHATSAPP', name: 'WHATSAPP' },
        ],
    },
    STAFF: {
        USER_ROLE: [
            {
                value: STAFF_ROLE.ROLE_MANAGER,
                name: STAFF_ROLE.ROLE_MANAGER,
            },
            {
                value: STAFF_ROLE.ROLE_OPERATOR,
                name: STAFF_ROLE.ROLE_OPERATOR,
            },
            {
                value: STAFF_ROLE.ROLE_HKJC_MANAGER,
                name: STAFF_ROLE.ROLE_HKJC_MANAGER,
            },
            {
                value: STAFF_ROLE.ROLE_HKJC_OPERATOR,
                name: STAFF_ROLE.ROLE_HKJC_OPERATOR,
            },
            {
                value: STAFF_ROLE.ROLE_EVENT_OPERATOR,
                name: STAFF_ROLE.ROLE_EVENT_OPERATOR,
            }
            // { value: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER_GUEST, name: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER_GUEST },
        ],
        ENABLED: [...BOOLEAN_CHOICES],
    },
    MERCHANT_DEVICE: {
        DEVICE_TYPE: [
            {
                value: MERCHANT_DEVICE_TYPE.PR,
                name: 'PR',
            },
            {
                value: MERCHANT_DEVICE_TYPE.STAFF_PR,
                name: 'STAFF_PR',
            },
            {
                value: MERCHANT_DEVICE_TYPE.KIOSK,
                name: 'KIOSK',
            },
            {
                value: MERCHANT_DEVICE_TYPE.TV,
                name: 'TV',
            },
            {
                value: MERCHANT_DEVICE_TYPE.COUNTER_KIOSK,
                name: 'COUNTER_KIOSK',
            },
            {
                value: MERCHANT_DEVICE_TYPE.COUNTER_TV,
                name: 'COUNTER_TV',
            },
            {
                value: MERCHANT_DEVICE_TYPE.PICKUP_TV,
                name: 'PICKUP_TV',
            },
            {
                value: MERCHANT_DEVICE_TYPE.CAMPAIGN_QUEUE,
                name: 'CAMPAIGN_QUEUE',
            },
            {
                value: MERCHANT_DEVICE_TYPE.TAILOR_MADE,
                name: 'TAILOR_MADE',
            },
            {
                value: MERCHANT_DEVICE_TYPE.MALL_KIOSK,
                name: 'MALL_KIOSK',
            },
            {
                value: MERCHANT_DEVICE_TYPE.SLIDESHOW_PLAYER,
                name: 'SLIDESHOW_PLAYER',
            },
            {
                value: MERCHANT_DEVICE_TYPE.FALLBACK,
                name: 'FALLBACK',
            },
            {
                value: MERCHANT_DEVICE_TYPE.MALL_TV,
                name: 'MALL_TV',
            },
        ],
        ACTIVATION_STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'E', name: { key: 'expired' } },
            { value: 'D', name: { key: 'deactive' } },
        ],
    },
    MERCHANT_USER: {
        USER_ROLE_FILTER: [
            {
                value: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER,
                name: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER,
            },
            // {
            //   value: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER_GUEST,
            //   name: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER_GUEST,
            // },
            {
                value: MERCHANT_USER_ROLE.ROLE_MERCHANT_API,
                name: MERCHANT_USER_ROLE.ROLE_MERCHANT_API,
            },
            {
                value: MERCHANT_USER_ROLE.ROLE_MERCHANT_REPORT_USER,
                name: MERCHANT_USER_ROLE.ROLE_MERCHANT_REPORT_USER,
            },
        ],
        USER_ROLE: [
            {
                value: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER,
                name: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER,
            },
            {
                value: MERCHANT_USER_ROLE.ROLE_MERCHANT_API,
                name: MERCHANT_USER_ROLE.ROLE_MERCHANT_API,
            },
            {
                value: MERCHANT_USER_ROLE.ROLE_MERCHANT_REPORT_USER,
                name: MERCHANT_USER_ROLE.ROLE_MERCHANT_REPORT_USER,
            },
            // { value: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER_GUEST, name: MERCHANT_USER_ROLE.ROLE_MERCHANT_USER_GUEST },
        ],
        CHANNEL: [
            { value: 'SELF', name: 'SELF' },
            { value: 'SALES', name: 'SALES' },
            { value: 'SALES_PRE_ASSIGN', name: 'SALES_PRE_ASSIGN' },
            { value: 'HSBC_GROUP', name: 'HSBC_GROUP' },
            { value: 'HSBC', name: 'HSBC' },
            { value: 'ADMIN', name: 'ADMIN' },
            { value: 'YEDPAY', name: 'YEDPAY' },
        ],
        ENABLED: [...BOOLEAN_CHOICES],
        ENABLED_MULTI_LOGIN: [...BOOLEAN_CHOICES],
        PRIVILEGE_ATTRIBUTE: [
            { value: 'SHOP', name: 'SHOP' },
            { value: 'GROUP', name: 'GROUP' },
        ],
        MERCHANT_ROLE: [
            { value: 'ROLE_OPERATOR', name: 'ROLE_OPERATOR' },
            { value: 'ROLE_MANAGER', name: 'ROLE_MANAGER' },
            { value: 'ROLE_PEAK_TRAM_OPERATOR', name: 'ROLE_PEAK_TRAM_OPERATOR' },
        ],
        TWO_FACTOR_LOGIN: [
            { value: 'NONE', name: 'NONE' },
            { value: 'SMS', name: 'SMS' },
            { value: 'EMAIL', name: 'EMAIL' },
            { value: 'WHATSAPP', name: 'WHATSAPP' },
        ],
    },
    MERCHANT_USER_GROUP: {
        SERVICE_TYPE: [
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'RACK_PRODUCT', name: 'RACK_PRODUCT' },
        ],
    },
    SYSTEM_USER: {
        USER_ROLE: [
            {
                value: SYSTEM_USER.USER_ROLE.ROLE_ADMIN,
                name: SYSTEM_USER.USER_ROLE.ROLE_ADMIN,
            },
            {
                value: SYSTEM_USER.USER_ROLE.ROLE_USER,
                name: SYSTEM_USER.USER_ROLE.ROLE_USER,
            },
            {
                value: SYSTEM_USER.USER_ROLE.ROLE_MANAGER,
                name: SYSTEM_USER.USER_ROLE.ROLE_MANAGER,
            },
            {
                value: SYSTEM_USER.USER_ROLE.ROLE_REST,
                name: SYSTEM_USER.USER_ROLE.ROLE_REST,
            },
            {
                value: SYSTEM_USER.USER_ROLE.ROLE_COUPON,
                name: SYSTEM_USER.USER_ROLE.ROLE_COUPON,
            },
            {
                value: SYSTEM_USER.USER_ROLE.ROLE_SYSTEM_ADMIN,
                name: SYSTEM_USER.USER_ROLE.ROLE_SYSTEM_ADMIN,
            },
        ],
        PRIVILEGE_ATTRIBUTE: [
            {
                value: SYSTEM_USER.PRIVILEGE_ATTRIBUTE.S,
                name: SYSTEM_USER.PRIVILEGE_ATTRIBUTE.SINGLE,
            },
            {
                value: SYSTEM_USER.PRIVILEGE_ATTRIBUTE.G,
                name: SYSTEM_USER.PRIVILEGE_ATTRIBUTE.GROUP,
            },
        ],
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'E', name: { key: 'expired' } },
            { value: 'D', name: { key: 'deactive' } },
        ],
        STATUS_DISPLAY: [
            { value: 'A', name: { key: 'active' } },
            { value: 'E', name: { key: 'expired' } },
        ],
        APIGROUP: [
            {
                value: SYSTEM_USER.APIGROUP.KAISHING,
                name: SYSTEM_USER.APIGROUP.KAISHING,
            },
            {
                value: SYSTEM_USER.APIGROUP.MAXIMS_ONE,
                name: SYSTEM_USER.APIGROUP.MAXIMS_ONE,
            },
            { value: SYSTEM_USER.APIGROUP.LINK, name: SYSTEM_USER.APIGROUP.LINK },
            {
                value: SYSTEM_USER.APIGROUP.CHINACHEM,
                name: SYSTEM_USER.APIGROUP.CHINACHEM,
            },
            {
                value: SYSTEM_USER.APIGROUP.WECHAT,
                name: SYSTEM_USER.APIGROUP.WECHAT,
            },
            { value: SYSTEM_USER.APIGROUP.SHKP, name: SYSTEM_USER.APIGROUP.SHKP },
        ],
    },
}
